/**
 * 上线初始化 API（/init/*）
 * 注意：这些接口返回 {ok:true} / {initialized,...} 等裸结构，不使用 unwrap 包装
 */
import client, { ApiError } from './client'

export interface InitStatus {
  initialized: boolean
  claimedByMe: boolean
}

function translateInitCode(code?: string): string {
  switch (code) {
    case 'invalid':
      return '初始化 Key 错误，请检查后重试'
    case 'claimed':
      return '此实例已被另一浏览器认领初始化，请使用认领者的浏览器完成配置'
    case 'not_claimed':
      return '当前浏览器未完成认领，请先输入初始化 Key'
    case 'invalid_email':
      return '管理员邮箱格式不正确'
    case 'weak_password':
      return '管理员密码过短（至少 8 位）'
    case 'create_user_failed':
      return '创建管理员失败，该账号可能已存在'
    case 'already_initialized':
      return '系统已完成初始化'
    default:
      return '请求失败，请重试'
  }
}

export const initApi = {
  async status(): Promise<InitStatus> {
    const resp = await client.get<InitStatus>('/init/status')
    return resp.data
  },

  async verify(key: string): Promise<{ ok: boolean }> {
    try {
      const resp = await client.post<{ ok: boolean }>('/init/verify', { key: key.trim() })
      return resp.data
    } catch (e) {
      const err = e as { response?: { data?: { code?: string }; status?: number } }
      throw new ApiError(err.response?.status ?? 0, translateInitCode(err.response?.data?.code))
    }
  },

  async complete(email: string, password: string): Promise<{ ok: boolean }> {
    try {
      const resp = await client.post<{ ok: boolean }>('/init/complete', {
        email: email.trim(),
        password,
      })
      return resp.data
    } catch (e) {
      const err = e as { response?: { data?: { code?: string }; status?: number } }
      throw new ApiError(err.response?.status ?? 0, translateInitCode(err.response?.data?.code))
    }
  },
}